/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import Carousel  from 'mfcl/Carousel';
import * as React from 'react';
import _getViewPort from '../../Utilities/get-view-port';
import { IMfrmContentReelViewProps } from './mfrm-content-reel';
import classname from 'classnames';

export default (props: IMfrmContentReelViewProps) => {
    const [loaded, setIsLoaded] = React.useState(false);
    const hideLoader = () => {
        setIsLoaded(true);
    };
    const styles = 'mfrm-content-reel__';
    const {
        config: { heading, headingColor },
        carouselItems
    } = props;
    const minDesktop = carouselItems.length === 4 ? 'min-desktop' : '';
    const mobile = _getViewPort(props.context) === 'sm';

    let headingDisplay = null;
    if (heading && heading.text) {
        const HeadingTag = heading.tag ? (`${heading.tag}` as keyof JSX.IntrinsicElements) : 'h2';
        headingDisplay = (
            <div className='row'>
                <HeadingTag className={classname(`${styles}heading`, headingColor ? `${styles}text-${headingColor}` : '')}>{heading.text}</HeadingTag>
            </div>
        );
    }

    React.useEffect(hideLoader, []);
    if (props.config.cardShape === 'square' && !mobile) {
        return (
            <div className='mfrm-content-reel'>
                {headingDisplay}
                <div className={`mfcl-carousel__container ${loaded ? '' : 'carousel-loading'}`}>
                    <Carousel
                        itemsToShow={1}
                        layoutGap={5}
                        ariaLabel='one'
                        hideIndicators
                        hideControls
                        controlStyle='legacy'
                        controlClass={`mfcl-carousel__button ${minDesktop}`}
                        disableEndButtons={mobile}
                        variableWidth
                    >
                        {carouselItems}
                    </Carousel>
                </div>
            </div>
        );
    } else {
        return (
            <div className='mfrm-content-reel'>
                {headingDisplay}
                <div className={`mfcl-carousel__container ${loaded ? '' : 'carousel-loading'}`}>
                    {mobile ? (
                        <div className='mfcl-carousel__mobile'>
                            <Carousel
                                itemsToShow={2}
                                ariaLabel='one'
                                hideIndicators
                                hideControls
                                disableControls
                                disableAutoShift
                                controlStyle='legacy'
                                controlClass={`mfcl-carousel__button ${minDesktop}`}
                                disableEndButtons={mobile}
                                variableWidth={mobile}

                            >
                                {carouselItems}
                            </Carousel>
                        </div>
                    ) : (
                        <Carousel
                            itemsToShow={4}
                            ariaLabel='one'
                            hideIndicators
                            hideControls
                            controlStyle='legacy'
                            controlClass={`mfcl-carousel__button ${minDesktop}`}
                            disableEndButtons={mobile}
                            variableWidth={mobile}
                            responsive={[
                                {
                                    breakpoint: 1150,
                                    itemsToShow: 3
                                },
                                {
                                    breakpoint: 564,
                                    itemsToShow: 1,
                                    layoutGap: 14
                                }
                            ]}
                        >
                            {carouselItems}
                        </Carousel>
                    )}
                </div>
            </div>
        );
    }
};
